var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-wrapper safe-area-top"},[_c('div',{staticClass:"number text-purple-gradient"},[_vm._v(_vm._s(_vm.index + 1))]),_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.step.info)}})])}
var staticRenderFns = []

export { render, staticRenderFns }